import { absolutePath } from "./absolutePath";

export const actionTextDirectUpload = {
  create: ({ params = {} } = {}) =>
    absolutePath("action_text_direct_upload", params),
};
